"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStylesWithBreakpoints = void 0;
const Breakpoint_1 = require("./Breakpoint");
const transformBreakpointToCSSMediaQuery_1 = require("./transformers/transformBreakpointToCSSMediaQuery");
/**
 * Generates CSS styles for an array of values with respect to breakpoints.
 * @param {number | number[] | Dimensions | Dimensions[]} values - The values to generate styles for.
 * @param {(value: number | Dimensions) => string} cssProperty - A function that takes a value and returns its corresponding CSS property string.
 * @returns {string} - The generated CSS string.
 */
const getStylesWithBreakpoints = (values, cssProperty) => {
    const valuesArray = Array.isArray(values) ? values : [values];
    return valuesArray
        .map((value, index) => {
        const propertyValue = cssProperty(value);
        return index === 0
            ? propertyValue
            : `
              ${(0, transformBreakpointToCSSMediaQuery_1.transformBreakpointToCSSMediaQuery)(Breakpoint_1.BREAKPOINT_ORDER[index], "up")} {
                  ${propertyValue}
              }
            `;
    })
        .join("");
};
exports.getStylesWithBreakpoints = getStylesWithBreakpoints;
//# sourceMappingURL=generateStyles.js.map